import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-83c029a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "puzzle-drag-and-drop" }
const _hoisted_2 = { class: "slots" }
const _hoisted_3 = { class: "slots" }

import { puzzle } from '@/data/puzzle'
import { PuzzleUserAnswer } from '@/types/Puzzle'
import PuzzleStepPlaceholder from './PuzzleStepPlaceholder.vue'
import PuzzleExtractPlaceholder from './PuzzleExtractPlaceholder.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
    currentUserAnswers: null
  },
  setup(__props: any) {

const props = __props as {
  currentUserAnswers: PuzzleUserAnswer[]
}



function allowDrop(ev: Event) {
  ev.preventDefault()
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function drop(ev: any) {
  ev.preventDefault()
  var data = ev.dataTransfer.getData('text/plain')

  let target = ev.target

  if (target.tagName === 'SPAN') {
    target = target.parentElement
  } else if (target.tagName === 'IMG' || target.tagName === 'BUTTON') {
    target = target.parentElement.parentElement

    // On drop find the actual puzzle video card
    while (target.classList.value.includes('puzzle-video-card')) {
      target = target.parentElement
    }

    //To avoid wrong video drop on extract placeholder
    if (target.classList.value.includes('puzzle-extract-placeholder')) {
      return
    }

    const extractVideoId = target.lastChild.id
    const extractVideoPlaceholder = document.getElementById(
      `puzzle-extract-placeholder-${extractVideoId}`
    )
    if (extractVideoPlaceholder != null) {
      extractVideoPlaceholder.appendChild(target.lastChild)
    }
  }

  const targetId = target.id.split('-').pop()

  //To avoid wrong video drop on extract wrong placeholder
  if (
    target.classList.value.includes('puzzle-extract-placeholder') &&
    targetId !== data
  ) {
    return
  }

  target.appendChild(document.getElementById(data))

  saveUserAnswers(parseInt(targetId), parseInt(data))
}

function saveUserAnswers(stepId: number, videoId: number) {
  const userAnswers = props.currentUserAnswers

  const userAnswersIndex = userAnswers.findIndex(
    (userAnswer) => userAnswer.stepId === stepId
  )

  if (userAnswersIndex !== -1) {
    userAnswers[userAnswersIndex].videoId = videoId
  } else {
    userAnswers.push({
      stepId,
      videoId,
    })
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(puzzle), (puzzleVideo) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "placeholder",
          key: puzzleVideo.id
        }, [
          _createVNode(PuzzleExtractPlaceholder, {
            puzzleVideo: puzzleVideo,
            id: puzzleVideo.id,
            onOndrop: drop,
            onOnDragOver: allowDrop
          }, null, 8, ["puzzleVideo", "id"])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(puzzle).length, (index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "placeholder",
          key: index
        }, [
          _createVNode(PuzzleStepPlaceholder, {
            "current-user-answers": props.currentUserAnswers,
            id: index,
            onOndrop: drop,
            onOnDragOver: allowDrop
          }, null, 8, ["current-user-answers", "id"])
        ]))
      }), 128))
    ])
  ]))
}
}

})